import { useTranslation } from "react-i18next";

export default function WhyDifferent() {
  const { t } = useTranslation();

  const items = [
    { icon: "ri-steering-2-line", title: t("why_1_title"), desc: t("why_1_desc") },
    { icon: "ri-group-line", title: t("why_2_title"), desc: t("why_2_desc") },
    { icon: "ri-compass-3-line", title: t("why_3_title"), desc: t("why_3_desc") },
    { icon: "ri-hand-heart-line", title: t("why_4_title"), desc: t("why_4_desc") },
  ];

  return (
    <section id="why" className="pt-10 md:pt-12 pb-14 md:pb-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <div className="eyebrow-brand text-sm md:text-base uppercase tracking-[0.35em] mb-3">— {t("why_eyebrow")} —</div>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.1] tracking-tight">
            {t("why_title")}
          </h2>
          <p className="mt-4 text-foreground-700 leading-relaxed">{t("why_sub")}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((it) => (
            <div key={it.title} className="bg-background-100 border border-background-200 rounded-lg p-6 flex flex-col">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-4">
                <i className={`${it.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-lg leading-tight text-foreground-950 mb-2">{it.title}</h3>
              <p className="text-sm text-foreground-700 leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}